import { Share2, Facebook, Linkedin, Link2, Check } from 'lucide-react';
import { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SocialShareBar({ article }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const url = window.location.href;
  const title = encodeURIComponent(article?.title || '');
  const slug = article?.slug;

  const track = (platform) => {
    if (slug) axios.post(`${API}/api/articles/${slug}/share`, { platform }).catch(() => {});
  };

  const share = (platform) => {
    track(platform);
    const urls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${title}&url=${encodeURIComponent(url)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      whatsapp: `https://wa.me/?text=${title}%20${encodeURIComponent(url)}`,
    };
    window.open(urls[platform], '_blank', 'width=600,height=400');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    track('copy');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center gap-2" data-testid="social-share-bar">
      <span className="text-xs text-gray-500 dark:text-gray-400 mr-1">
        <Share2 size={14} className="inline" /> Share:
      </span>
      {[
        { name: 'facebook', icon: <Facebook size={15} />, color: 'hover:text-blue-600' },
        { name: 'twitter', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>, color: 'hover:text-gray-900 dark:hover:text-white' },
        { name: 'linkedin', icon: <Linkedin size={15} />, color: 'hover:text-blue-700' },
        { name: 'whatsapp', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>, color: 'hover:text-green-600' },
      ].map(s => (
        <button
          key={s.name}
          onClick={() => share(s.name)}
          data-testid={`share-${s.name}`}
          className={`p-1.5 rounded-full text-gray-400 ${s.color} transition-colors`}
          title={`Share on ${s.name}`}
        >
          {s.icon}
        </button>
      ))}
      <button
        onClick={copyLink}
        data-testid="share-copy-link"
        className="p-1.5 rounded-full text-gray-400 hover:text-navy dark:hover:text-white transition-colors"
        title="Copy link"
      >
        {copied ? <Check size={15} className="text-green-500" /> : <Link2 size={15} />}
      </button>
    </div>
  );
}
